import { render } from "./SidebarItem.vue?vue&type=template&id=64218ced&scoped=true&ts=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"

import "./SidebarItem.vue?vue&type=style&index=0&id=64218ced&lang=scss&scoped=true"
import "./SidebarItem.vue?vue&type=style&index=1&id=64218ced&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64218ced"]])

export default __exports__